"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Title = _interopRequireDefault(require("../Title/Title"));

require("../modal/ModalComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CommonModal = function CommonModal(_ref) {
  var visible = _ref.visible,
      handleOk = _ref.handleOk,
      handleCancel = _ref.handleCancel,
      footer = _ref.footer,
      confirmLoading = _ref.confirmLoading,
      closable = _ref.closable,
      children = _ref.children,
      className = _ref.className,
      title = _ref.title,
      modalTitleCls = _ref.modalTitleCls,
      width = _ref.width,
      mask = _ref.mask,
      destroyOnClose = _ref.destroyOnClose;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_antd.Modal, {
    footer: footer || "",
    visible: visible || false,
    confirmLoading: confirmLoading ? confirmLoading : false,
    onOk: handleOk,
    onCancel: handleCancel,
    closable: closable || "true",
    className: "".concat(className || "", " iiht-ant-modal"),
    title: /*#__PURE__*/_react["default"].createElement(_Title["default"], {
      className: "".concat(modalTitleCls || "")
    }, title),
    width: width,
    mask: mask || true,
    getContainer: ".content",
    destroyOnClose: destroyOnClose
  }, children));
};

var _default = CommonModal;
exports["default"] = _default;